export default __CONFIG__;



// WEBPACK FOOTER //
// ./config/index.js